import { render, staticRenderFns } from "./wHasmany.vue?vue&type=template&id=04b92b7c&scoped=true&"
import script from "./wHasmany.vue?vue&type=script&lang=js&"
export * from "./wHasmany.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04b92b7c",
  null
  
)

export default component.exports